export const loginFormStyle = {
	wrapper: {
		position: 'relative',
		marginTop: '140px',
		maxWidth: '374px',
		margin: '0 12px',
		width: '100%',
	},

	title: {
		paddingBottom: '16px',

		'& .MuiTypography-h5': {
			fontSize: '34px',
			lineHeight: '42px',
			textTransform: 'capitalize',
		},
	},
};
